import { OrderById } from "../modules/orders/ui/orderById";

export const OrdersByIdPage = () => {
  return (
    // <AdminMenuLayout pageDescription="OrderById" title="OrderById">
    //   <WrapperOrderById>
    <OrderById />
    //   </WrapperOrderById>
    // </AdminMenuLayout>
  );
};
